<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <footer class="bg-navy-50 py-4 text-center text-sm text-gray-500">
      <p>Built on DCAD public data · Not affiliated with Dallas Central Appraisal District</p>
    </footer>
  </div>
</template>
